import { api } from '@/services';

export default {
  async saveNCM({ dispatch }, payload) {
    try {
      const obj = payload;
      obj.quantidade = parseInt(payload.quantidade, 10);
      obj.valorUnitario = parseFloat(payload.valorUnitario, 10);
      // obj.empresa = parseInt(payload.empresa, 10);

      if (obj.ativo === 1) {
        obj.ativo = true;
      }

      if (obj.ativo === 0) {
        obj.ativo = false;
      }

      if (obj.id) {
        return await api.put(`/processo/solicitar/ncm/${obj.id}`, obj).then(({ data }) => data);
      }
      return await api.post('/processo/solicitar/ncm', obj).then(({ data }) => data);
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível salvar o produto!', {
        root: true,
      });
    }
  },
  async getRecentes() {
    const retorno = await api.get('/processo/solicitar/ncm/recentes');
    return retorno.data;
  },
  async deleteNCM({ dispatch }, payload) {
    try {
      return await api.delete(`/processo/solicitar/ncm/${payload}`).then(({ data }) => data);
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível remover o produto!', {
        root: true,
      });
    }
  },
  async getRawNCM({ dispatch }, payload) {
    try {
      return await api.get(`/ncm/produto?termo=${payload}`).then(({ data }) => data);
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível buscar o produto!', {
        root: true,
      });
    }
  },
  async getNCM({ dispatch }, payload) {
    try {
      return await api.get(`/processo/solicitar/ncm/${payload}`).then(({ data }) => data);
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível buscar o produto!', {
        root: true,
      });
    }
  },
  async getNCMById({ dispatch }, payload) {
    try {
      return await api.get(`/processo/solicitar/ncm/id/${payload}`).then(({ data }) => data[0]);
    } catch (err) {
      return dispatch('setGlobalError', 'Não foi possível buscar o produto!', {
        root: true,
      });
    }
  },
};
